﻿<div *ngIf="!breadCrumbWithMenuBar" fxLayout="row" #breadCrumbView id="breadcrumb"
  [ngClass]="breadcrumbs.length>1 ? 'breadcrumb pl-32 pr-32':'hide-breadcrumb'">
  <ul>
    <ng-container *ngFor="let breadcrumb of breadcrumbs;let last = last;">
      <li *ngIf="!breadcrumb.isHide" ngClass.xs="text-truncate float-left wm-80"
        ngClass.sm="text-truncate float-left wm-80">
        <a *ngIf="!last && breadcrumb.type === 'link'" [routerLink]="[breadcrumb.url]"
          [queryParams]="breadcrumb.queryParams">
          {{ breadcrumb.isTranslate ? (breadcrumb.label | translate) : breadcrumb.label }}
        </a>
        <span [class.font-size-14]="last" *ngIf="last || breadcrumb.type === 'non-link'">
          {{ breadcrumb.isTranslate ? (breadcrumb.label | translate) : breadcrumb.label }}
        </span>
      </li>
    </ng-container>
  </ul>
</div>
<div *ngIf="breadCrumbWithMenuBar" #breadCrumbView id="breadcrumb" fxLayout="row" fxLayoutAlign="start center"
  [ngClass]="nonHideBreadcrumbs.length>1 ? 'breadcrumb-with-menu':'hide-breadcrumb'">
  <div *ngIf="nonHideBreadcrumbs.length>1" ngClass.sm="text-truncate float-left wm"
    ngClass.gt-sm="text-truncate float-left wm" class="first-breadcrumb-color" fxHide.xs="true" fxShow.gt-xs="true">
    <ng-container *ngFor="let breadcrumb of nonHideBreadcrumbs; first as isFirst">
      <span *ngIf="isFirst && breadcrumb.type === 'link'">
        <a *ngIf="isFirst && breadcrumb.type === 'link'" [routerLink]="[breadcrumb.url]"
          [queryParams]="breadcrumb.queryParams">
          {{ breadcrumb.isTranslate ? (breadcrumb.label | translate) : breadcrumb.label }}
        </a>
      </span>
      <span *ngIf="isFirst && breadcrumb.type === 'non-link'">
        {{ breadcrumb.isTranslate ? (breadcrumb.label | translate) : breadcrumb.label }}
      </span>
    </ng-container>

  </div>
  <div *ngIf="nonHideBreadcrumbs.length > 2" fxHide.xs="true" fxShow.gt-xs="true">
    <span class="p-8 slash-icon">/</span>
  </div>
  <div *ngIf="nonHideBreadcrumbs.length > 2" fxHide.xs="true" fxShow.gt-xs="true">
    <ng-container [ngTemplateOutlet]="MatButtonOptions"
      [ngTemplateOutletContext]="{ $implicit: 1 }">
    </ng-container>
  </div>
  <div *ngIf="nonHideBreadcrumbs.length > 1" fxShow.xs="true" fxHide.gt-xs="true">
    <ng-container [ngTemplateOutlet]="MatButtonOptions"
      [ngTemplateOutletContext]="{ $implicit: 0 }">
    </ng-container>
  </div>
  <div *ngIf="nonHideBreadcrumbs.length>1" class="text-truncate float-left wm last-breadcrumb-color">
    <span *ngIf="nonHideBreadcrumbs.length > 1" class="p-8 slash-icon">/</span>
    <ng-container *ngFor="let breadcrumb of nonHideBreadcrumbs; last as isLast;">
      <span *ngIf="isLast">{{ breadcrumb.isTranslate ? (breadcrumb.label | translate) : breadcrumb.label }}</span>
    </ng-container>
  </div>
</div>

<ng-template #MatButtonOptions let-index>
  <button mat-icon-button [matMenuTriggerFor]="bMenu">
    <i class="material-icons font-size-22 mt-8">more_horiz</i>
  </button>
  <mat-menu #bMenu="matMenu">
    <ng-container *ngFor="
        let breadcrumb of nonHideBreadcrumbs | slice: index:nonHideBreadcrumbs.length - 1;
        let i = index
      ">
      <button mat-menu-item [disabled]="breadcrumb.type == 'non-link'">
        <span><a *ngIf="breadcrumb.type === 'link'" [routerLink]="[breadcrumb.url]"
            [queryParams]="breadcrumb.queryParams">
            {{ breadcrumb.isTranslate ? (breadcrumb.label | translate) : breadcrumb.label }}
          </a></span>
        <span *ngIf="breadcrumb.type === 'non-link'">{{ breadcrumb.isTranslate ? (breadcrumb.label | translate) :
          breadcrumb.label }}</span>
      </button>
    </ng-container>
  </mat-menu>
</ng-template>